<div id="claim-assign-container">
  <p-blockUI [blocked]="loading === true" />
  <div>
    <div style="text-align: right">
      <div style="text-align: right">
        <app-progress-spinner [enabled]="saving" />
      </div>
    </div>
  </div>
  <app-progress-spinner [enabled]="!elements" />
  <div class="content">
    <div class="button-wrapper group content-header">
      <button
        pButton
        class="refresh-button width-twenty"
        icon="fa fa-fw fa-refresh"
        (click)="refresh()"
      ></button>
    </div>

    <div [style.display]="!elements ? 'none' : ''">
      <app-general-grid
        [values]="elements"
        [columns]="columns"
        [loading]="loading"
        [totalRecords]="totalRecords"
        [filterable]="true"
        [screenName]="screenName"
        [rows]="rows"
        [lazy]="true"
        (lazyLoad)="lazyLoad($event)"
        [includeExportCSV]="false"
        (changeViewEvent)="changeViewEvent($event)"
        scrollHeight="75vh"
        [usePaginator]="true"
        [alwaysShowPaginator]="true"
        [rowsPerPageOptions]="[50, 100, 200]"
        #grid
      />
    </div>

    <p-dialog
      [header]="dialogHeader"
      [(visible)]="displayDialog"
      showEffect="fade"
      [modal]="true"
      (onHide)="dialogClosed()"
      [transitionOptions]="'0ms'"
      [style]="{ width: '1000px' }"
    >
      <form [formGroup]="claimRoleForm">
        <div>
          <div class="no-padding modal-input">
            <div class="label">{{ 'ADMIN.LABEL.NAME' | translate }}:</div>
            <div>
              <input type="text" pInputText formControlName="name" />
            </div>
          </div>
          <div style="width: 100%">
            <p-pickList
              [source]="sourcePicklist"
              [target]="targetPicklist"
              targetHeader="{{ 'COMMON.LABEL.ASSIGNED_ROLES' | translate }}"
              [dragdrop]="false"
              sourceHeader="{{ 'COMMON.LABEL.AVAILABLE_ROLES' | translate }}"
              [responsive]="true"
              [showSourceControls]="false"
              [showTargetControls]="false"
              [sourceStyle]="{
                height: '400px',
                'box-shadow': 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
              }"
              [targetStyle]="{
                height: '400px',
                'box-shadow': 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
              }"
              filterBy="name"
              #pickList
            >
              <ng-template let-claim pTemplate="item">
                <div>
                  <div>
                    <h5>{{ claim.name }}</h5>
                  </div>
                </div>
              </ng-template>
            </p-pickList>
          </div>
          <div style="margin-top: 8px">
            @if (canEdit) {
              <div class="button-wrapper">
                <button
                  pButton
                  label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
                  icon="fa fa-fw fa-save"
                  (click)="saveClaim()"
                  [disabled]="!this.claimRoleForm.valid"
                ></button>
              </div>
            }
          </div>
        </div>
      </form>
    </p-dialog>
  </div>
</div>
